import type { UserCredential } from 'firebase/auth';
import { firebaseAuthService } from '@/core/services';

export class LoginComMetaUseCase {
  async execute(): Promise<UserCredential> {
    return firebaseAuthService.signInWithMeta();
  }
}
